import React from "react";
import type { CRMChannel } from "@jugl-web/rest-api";
import { ContactIntelligenceFieldValue } from "./components/ContactIntelligenceFieldValue";
import { ContactIntelligenceRowData } from "../../types";

export const ContactIntelligenceFieldRow: React.FC<
  Omit<ContactIntelligenceRowData, "id"> & {
    onConversationNavigate?: (params: {
      channel: CRMChannel;
      convId: string;
    }) => void;
  }
> = ({ label, value, onConversationNavigate }) => (
  <div className="flex items-center gap-2">
    <div className="flex w-[135px] shrink-0 items-center">
      <span className="text-xs leading-[140%] font-normal tracking-[0.12px] text-dark-700">
        {label}:
      </span>
    </div>
    <ContactIntelligenceFieldValue
      value={value}
      onConversationNavigate={onConversationNavigate}
    />
  </div>
);
